/* @ngInject */

export default (
  $rootScope,
  $scope,
  webpage,
  workflowService,
  workflowsService,
  eventService,
  actionService,
  uiService
) => {
  $scope.Model = {
    availableWorkflows: [],
    workflowsList: null,
    isArchive: false,
    isReady: false
  };

  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');

  if ($rootScope.CurrentAccount.isAdministrator) {
    workflowsService
      .getAvailable({ isActive: !$scope.Model.isArchive })
      .then((data) => {
        // Set Model values
        $scope.Model.availableWorkflows = data;
      })
      .then(() => {
        // Declare Model as Ready and start rendering the page
        webpage.pageTitle('Workflows : Settings');
        $scope.Model.isReady = true;
      });
  }

  /*
   * Events available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.$on('workflowDuplicate', () => {
    workflowsService.clearCache();
    actionService
      .duplicateDocuments(
        $scope.Model.workflowsList.getSelected(),
        workflowService.readWorkflow,
        workflowService.createWorkflow,
        $scope.Model.workflowsList.setDataAppend,
        'name',
        ' copy',
        'workflow(s)'
      )
      .then(() => {
        eventService.credentialsChanged();
      });
  });

  $scope.$on('workflowDelete', ($event) => {
    workflowsService.clearCache();
    if ($scope.isWorkflowDeleteable($scope.Model.workflowsList.getSelected())) {
      eventService.workflowDelete({
        event: $event,
        selectedWorkflows: $scope.Model.workflowsList.getSelected(),
        organizationName: $rootScope.CurrentOrganization.getName()
      });
    } else {
      uiService.toast({
        text: {
          p1: 'One or more of selected Workflow(s)',
          p2: 'are inherited and as such',
          p3: 'cannot be deleted'
        },
        warn: true
      });
    }
  });

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.isWorkflowDeleteable = (workflow) => {
    if (!_.isArray(workflow)) {
      return (
        $rootScope.CurrentOrganization.isRoot() ||
        (!$rootScope.CurrentOrganization.isRoot() && !_.isUuid(workflow.idClone))
      );
    }
    return (
      $rootScope.CurrentOrganization.isRoot() ||
      (!$rootScope.CurrentOrganization.isRoot() &&
        _.some(_.map(workflow, 'idClone'), (idClone) => {
          return !_.isUuid(idClone);
        }))
    );
  };

  $scope.toggleProject = ($event, workflow) => {
    workflowService
      .updateWorkflow({
        id: workflow.id,
        isProject: !workflow.isProject
      })
      .then((result) => {
        if (result.status) {
          workflowsService.clearCache();
          uiService.toast({
            text: {
              p1: 'Workflow',
              p2: workflow.getName(),
              p3: `set as ${workflow.isProject}` ? 'project' : 'board'
            }
          });
        }
      });
  };

  $scope.workflowDeleted = (workflow) => {
    workflowsService.clearCache();
    $scope.Model.workflowsList.removeData(workflow);
  };

  $scope.listChange = (list, data, isSelected) => {
    $scope.$parent.Model.childStateHasSelection = isSelected || list.isSelectedAny();
  };

  $scope.listReady = (list) => {
    $scope.Model.workflowsList = list;
  };
};
